.ui-emojis-container {
    width: 320px;
    height: 320px;
    background-color: #1a1a1a;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
    border: 1px solid #333;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: #fff;
    position: relative;
    /* For absolute positioning context if needed */
}

/* Header */
.ui-emojis-header {
    height: 40px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #333;
    padding: 0 10px;
    background-color: #222;
}

.ui-tab {
    background: transparent;
    border: none;
    color: #888;
    padding: 0 12px;
    height: 100%;
    font-size: 13px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: all 0.2s;
    font-weight: 500;
}

.ui-tab:hover {
    color: #fff;
}

.ui-tab.active {
    color: #fff;
    border-bottom-color: #646cff;
    /* Accent color */
}

.ui-tab.remove {
    margin-left: auto;
    /* Push to right */
    color: #ff6b6b;
}

.ui-tab.remove:hover {
    background-color: rgba(255, 107, 107, 0.1);
}


/* Search Bar */
.ui-search-container {
    padding: 8px 10px;
    background-color: #222;
    border-bottom: 1px solid #333;
}

.ui-search-input-wrapper {
    display: flex;
    align-items: center;
    background-color: #111;
    border: 1px solid #333;
    border-radius: 6px;
    padding: 4px 8px;
    height: 28px;
}

.ui-search-input {
    background: transparent;
    border: none;
    color: #fff;
    font-size: 13px;
    margin-left: 6px;
    width: 100%;
    outline: none;
}

.ui-search-input::placeholder {
    color: #555;
}

/* Content */
.ui-emojis-content {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    background-color: #1a1a1a;
}

.emoji-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(32px, 1fr));
    gap: 4px;
}

.emoji-item {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    background: transparent;
    border: none;
    cursor: pointer;
    border-radius: 6px;
    transition: background 0.1s;
}

.emoji-item:hover {
    background-color: rgba(255, 255, 255, 0.1);
    transform: scale(1.1);
}

.upload-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #666;
    font-size: 14px;
}

/* Footer Filter */
.ui-emojis-footer {
    height: 30px;
    /* Small footer */
    border-top: 1px solid #333;
    display: flex;
    align-items: center;
    padding: 0 10px;
    background-color: #222;
    gap: 5px;
}

.filter-btn {
    width: 24px;
    height: 24px;
    /* < 16px requested, but 16px clickable is tiny. 
                     User said: "menu de no mas de 16px de alto"
                     I will respect the container height constraint or icon size. */
    max-height: 16px;
    /* Strict interpretation if needed content-wise */
    background: transparent;
    border: none;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
}

.filter-btn svg {
    width: 12px;
    height: 12px;
}

.filter-btn:hover,
.filter-btn.active {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.1);
}